import { FC, ReactNode } from 'react';

import { Button, VStack } from '@ui-furniture/elements';
import { x } from '@ui-furniture/style';

export const PopoverMenu: FC<{
  items: Array<{
    id: string;
    label: ReactNode;
    onClick: () => void;
  }>;
}> = ({ items }) => (
  <VStack alignItems='stretch' minWidth='160px' maxW='100%' py='md' gap='sm'>
    {items.map(({ id, label, onClick }) => (
      <x.div key={id}>
        <Button
          type='button'
          w='100%'
          variant='blank'
          onClick={onClick}
          px='md !important'
          py='sm !important'
          textAlign='left'
          transition={{ _: 'slow', hover: 'base' }}
          backgroundColor={{
            hover: 'palette-primary',
          }}
          color={
            {
              hover: 'palette-primary-text',
            } as any
          }
        >
          {label}
        </Button>
      </x.div>
    ))}
  </VStack>
);
